import {
  EVENT_LISTENER_METHODS,
  eventBus,
  toggleParticipantListVisible,
  useConfigStore,
  useOrderedParticipants,
  useTranslation,
} from '@cometchat/calls-sdk-core';
import React, { useState } from 'react';
import Icon from '../icon/Icon.web';
import ParticipantItem from './participant-item/ParticipantItem.web';
import './style.css';

const ParticipantList: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const participants = useOrderedParticipants();
  const { t } = useTranslation();
  const hideShareInviteButton = useConfigStore(
    state => state.hideShareInviteButton,
  );

  // Basic filtering logic (case-insensitive)
  const filteredParticipants = React.useMemo(
    () =>
      participants.filter(p =>
        p.name.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    [participants, searchTerm],
  );

  return (
    <div className="cometchat-calls-participant-list-container">
      {/* Header */}
      <div className="cometchat-calls-participant-list-header">
        <div className="cometchat-calls-participant-list-header-text">
          <h2 className="cometchat-calls-participant-list-title">
            {t('participantList.header.title')} ({filteredParticipants.length})
          </h2>
        </div>
        <button
          className="cometchat-calls-participant-list-close-button"
          onClick={toggleParticipantListVisible}
          aria-label={t('participantList.header.closeButton')}>
          <Icon name="close" size={24} fill="#FFFFFF" />
        </button>
      </div>

      {/* Search Bar */}
      <div className="cometchat-calls-participant-search-container">
        {!hideShareInviteButton && (
          <div className="cometchat-calls-participant-list-share-invite-button-container">
            <button
              className="cometchat-calls-participant-list-share-invite-button"
              data-testid="cometchat-calls-share-invite-button"
              onClick={() => {
                eventBus.publish({
                  type: EVENT_LISTENER_METHODS.ButtonClickListener
                    .onShareInviteButtonClicked,
                });
              }}
              type="button">
              <Icon name="invite" size={24} fill="#FFFFFF" />
              Invite User
            </button>
          </div>
        )}
        <div className="cometchat-calls-participant-search-input-container">
          <div className="cometchat-calls-participant-search-input-wrapper">
            <Icon name="search" size={24} fill="#858585" />
            <input
              type="text"
              placeholder={t('participantList.search.placeholder')}
              className="cometchat-calls-participant-search-input"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Participant List Area */}
      <div className="cometchat-calls-participants-scroll-area">
        {filteredParticipants.length === 0 ? (
          <div className="cometchat-calls-participant-list-empty-state">
            <div className="cometchat-calls-participant-list-empty-state-icon">
              <Icon
                name="empty-search"
                size={120}
                fill="var(--cometchat-calls-icon-color-tertiary)"
              />
            </div>
            <div className="cometchat-calls-participant-list-empty-state-text">
              <div className="cometchat-calls-participant-list-empty-state-title">
                {t('participantList.emptyState.title')}
              </div>
              <p className="cometchat-calls-participant-list-empty-state-subtitle">
                {t('participantList.emptyState.subtitle')}
              </p>
            </div>
          </div>
        ) : (
          filteredParticipants.map(participant => (
            <ParticipantItem key={participant.ruid} participant={participant} />
          ))
        )}
      </div>
    </div>
  );
};

export default ParticipantList;
